import { LOADING, SET_CAMPAIGN, SET_CAMPAIGNS, SET_CAMPAIGNS_ASSIGMENTS } from '../action/types'

const initialState = {
    campaignAssigned: undefined,
    campaigns: undefined,
    loading: false,
    assignments: undefined
}

export default function campaignReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CAMPAIGN:
            return {
                ...state,
                campaignAssigned: action.payload
            }
        case SET_CAMPAIGNS:
            return {
                ...state,
                campaigns: [...action.payload]
            }
        case LOADING:
            return {
                ...state,
                loading: action.payload
            }
        case SET_CAMPAIGNS_ASSIGMENTS:
            return {
                ...state,
                assignments: [...action.payload]
            }
        default:
            return state
    }
}